import { gql } from '@apollo/client';

/**
 * Change a WooCommerce order status via WPGraphQL WooCommerce.
 * All Bookings rows are orders; booking status maps to order.status.
 */
export const UPDATE_ORDER_STATUS = gql`
  mutation UpdateOrderStatus($orderId: Int!, $status: OrderStatusEnum!) {
    updateOrder(input: { orderId: $orderId, status: $status }) {
      order {
        databaseId
        status
      }
    }
  }
`;

export type OrderStatusEnum =
  | 'PENDING'
  | 'ON_HOLD'
  | 'PROCESSING'
  | 'COMPLETED'
  | 'CANCELLED'
  | 'CANCEL_REQUEST'
  | 'REFUNDED'
  | 'FAILED'
  | string;

export interface UpdateOrderStatusData {
  updateOrder: {
    order: {
      databaseId: number;
      status: string;
    } | null;
  } | null;
}

export interface UpdateOrderStatusVariables {
  orderId: number;
  status: OrderStatusEnum;
}
